const Heading = ({ item }) => {
  return (
    <>
    {item.content?.trim() ?
    <div className="">
        <p className="heading fs-15 text-black">{item.content}</p>
        <p className="text fs-14 text-black" style={{ whiteSpace: "pre-line" }}>{item.answer}</p>
    </div> : <></>}
    </>
  )
}

export default Heading